import { navigate } from "gatsby";

export const onInitialClientRender = () => {
  if (typeof window === "undefined" || !window.pagePath) return;

  const normalizePath = (path) => path.replace(/\/+([?#].*)?$/, "$1") || "/";
  const pathname = window.location.pathname === "/"
    ? "/"
    : `${window.location.pathname.replace(/\/+$/, "")}/`;
  const currentPath = `${pathname}${window.location.search}${window.location.hash}`;

  if (normalizePath(window.pagePath) !== normalizePath(currentPath) && window.location.pathname !== "/") {
    setTimeout(() => navigate(currentPath, { replace: true }), 0);
  }
};
